module.exports = __webpack_public_path__ + "static/media/CyberTall.e7577770.jpg";